import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import { Paper, Box, Typography, Button, Grid, Stack } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { MotionInView, varFadeIn } from '../../animate';
import { events } from '../faqs/data';
import { PATH_PAGE } from 'src/routes/paths';

MemberCard.propTypes = {
  caseStudy: PropTypes.object.isRequired,
};

function MemberCard({ caseStudy }) {
  const { id, imageUrl, title1, date, venue, title2 } = caseStudy;
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const handleNavigation = () => {
    if (title2) {
      // Ensure `title2` is passed correctly to the navigation path
      navigate(`/events/${title2}`);
    } else {
      enqueueSnackbar('There is no detail page', { variant: 'warning' });
    }
  };
  

  return (
    <Paper
      variant="outlined"
      key={id}
      sx={{
        border: '2px solid #e6e6e6',
        borderRadius: 0.1,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Box
        component="img"
        src={imageUrl}
        sx={{ width: '100%', height: '210px', objectFit: 'cover', flexShrink: 0 }}
      />
      <Box sx={{ p: 2, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography
          sx={{
            mt: 1,
            mb: 2,
            fontSize: '26px',
            fontWeight: 600,
            color: '#2f78c4',
            lineHeight: 1.2,
            cursor: 'pointer',
            '&:hover': {
              color: '#000048',
            },
            fontFamily:
              '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 3,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          onClick={handleNavigation}
        >
          {title1}
        </Typography>
        <Typography
          sx={{
            mt: 2,
            fontSize: '20px',
            fontWeight: 450,
            color: '#000048',
            lineHeight: 1.2,
            fontFamily:
              '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
          }}
        >
          {date} {venue}
        </Typography>
      </Box>
      {/* <Box sx={{ p: 2 }}>
        <Button
          onClick={handleNavigation}
          size="small"
          sx={{
            cursor: 'pointer',
            color: '#2f78c4',
            fontWeight: '600',
            fontSize: '15px',
          }}
          endIcon={<Stack className="bx--right-arrow" style={{ fontSize: '1rem', marginTop: 0.5 }} />}
        >
          Know More
        </Button>
      </Box> */}
    </Paper>
  );
}

export default function ConductedEvents() {
  return (
    <Grid container spacing={2} sx={{ textAlign: 'left', overflow: 'hidden' }}>
      {events.map((caseStudy) => (
        <Grid item xs={12} sm={6} md={3} key={caseStudy.id} sx={{ display: 'flex' }}>
          <MotionInView variants={varFadeIn} sx={{ display: 'flex', flexGrow: 1 }}>
            <MemberCard key={caseStudy.title1} caseStudy={caseStudy} />
          </MotionInView>
        </Grid>
      ))}
    </Grid>
  );
}